import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { Subscription, Observable } from 'rxjs';

export interface SocialMediaLinks {
  facebook: string;
  facebookSoccer: string;
  twitter: string;
  linkedin: string;
  pinterest: string;
  youtube: string;
}

@Component({
  selector: 'edge-global-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class GlobalFooterComponent implements OnInit {
  copyrightDate = new Date().getFullYear();
  socialMediaLinks$: Observable<SocialMediaLinks> =
    new Observable<SocialMediaLinks>();
  socialMediaLinksSubscription: Subscription = new Subscription();

  private socialMediaLinks: SocialMediaLinks = {
    facebook: 'https://www.facebook.com/GoArmyEdgeFootball',
    facebookSoccer: 'https://www.facebook.com/GoArmyEdgeSoccer',
    twitter: 'https://twitter.com/goarmyedge',
    linkedin: 'https://www.linkedin.com',
    pinterest: 'https://www.pinterest.com',
    youtube: 'https://www.youtube.com/goarmyedge'
  };

  constructor(private store: Store<fromRoot.State>) {}

  ngOnInit(): void {
    this.socialMediaLinks$ = this.store.pipe(
      select(fromRoot.getSocialMediaLinks)
    );

    if (this.socialMediaLinks$) {
      this.socialMediaLinksSubscription = this.socialMediaLinks$.subscribe(
        (links) => {
          this.socialMediaLinks = links;
        }
      );
    }
  }
}
